import _implicitStylesheets from "./queuedView.css";

import _implicitScopedStylesheets from "./queuedView.scoped.css?scoped=true";

import _myTargetDataTable from "my/targetDataTable";
import _lightningInput from "lightning/input";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, t: api_text, h: api_element, c: api_custom_element} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_element("div", {
    classMap: {
      "queued-view__position": true
    },
    key: 0
  }, [api_element("div", {
    key: 1
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_neutral": true,
      "slds-align_absolute-left": true
    },
    attrs: {
      "data-my-id": "clear-button"
    },
    key: 2,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleClearList))
    }
  }, [api_text("Clear List")]), api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_neutral": true,
      "slds-float_right": true
    },
    attrs: {
      "data-my-id": "validate-button",
      "disabled": $cmp.disableValidate ? "" : null
    },
    key: 3,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleValidateAndDeploy))
    }
  }, [api_text("Validate")])]), api_element("div", {
    key: 4
  }, [api_custom_element("my-target-data-table", _myTargetDataTable, {
    props: {
      "items": $cmp.selectedItems
    },
    key: 5
  }, [])]), api_element("div", {
    classMap: {
      "queued-view-footer__style": true
    },
    key: 6
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_brand": true,
      "slds-float_right": true,
      "deploy-button__padding": true
    },
    attrs: {
      "data-my-id": "deploy-button",
      "disabled": $cmp.disableDeploy ? "" : null
    },
    key: 7,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.handleValidateAndDeploy))
    }
  }, [api_text("Deploy")]), api_custom_element("lightning-input", _lightningInput, {
    classMap: {
      "overwrite-all__padding": true
    },
    attrs: {
      "data-my-id": "overwriteItemId"
    },
    props: {
      "type": "checkbox",
      "label": "Overwrite all existing items on targets",
      "disabled": $cmp.disableOverwrite
    },
    key: 8,
    on: {
      "change": _m3 || ($ctx._m3 = api_bind($cmp.handleOverwriteCheckbox))
    }
  }, [])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-queuedView_queuedView"
